import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import {
  AuthenticationGuard,
  AuthenticationService,
  ConfigService,
  Environment
} from '@core-argos-angular-artifact/core';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard extends AuthenticationGuard {
  constructor(
    protected readonly router: Router,
    protected readonly authService: AuthenticationService,
    private readonly configService: ConfigService
  ) {
    super(authService);
  }

  manageError(): UrlTree {
    return this.manageRedirect();
  }

  manageLoadError(): UrlTree {
    return this.manageRedirect();
  }

  changePage(url: string): void {
    window.location.href = url;
  }

  private manageRedirect(): UrlTree {
    const env = this.configService.getEnv();

    if (env === Environment.DEV) {
      return this.router.createUrlTree(['/application-landing']);
    } else {
      this.changePage(this.configService.getConfig()?.productUrl);
    }
  }
}
